export const BASE_URL=process.env.REACT_APP_AI_API_URL

export const createHeaders = (token="singhyogesh2104@gmail.com") => {
    const headers = new Headers();
    headers.append("Authorization", `${token}`);
    headers.append("Content-Type", "application/json");
    return headers;
};